<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" class="single-spa-vue">
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input v-model:value="form.id" placeholder="请输入id"/>
                </a-form-item>
                <a-form-item label="undefined" name="groupNumber">
                    <a-input v-model:value="form.groupNumber" placeholder="请输入undefined"/>
                </a-form-item>
            </div>
            <a-form-item label="字典项名称" name="dictTitle">
                <a-input v-model:value="form.dictTitle" placeholder="请输入字典项名称"/>
            </a-form-item>
            <a-form-item label="字典项值" name="dictValue">
                <a-input v-model:value="form.dictValue" placeholder="请输入字典项值"/>
            </a-form-item>
            <a-form-item label="style 样式" name="style">
                <a-textarea v-model:value="form.style" placeholder="请输入 style 样式" :auto-size="{minRows:3,maxRows:6}"/>
            </a-form-item>
            <a-form-item label="是否启用" name="enabled">
                <switch-input v-model:value="form.enabled"/>
            </a-form-item>
            <a-form-item label="排序" name="sort">
                <a-input-number v-model:value="form.sort" :min="0" :precision="0"/>
            </a-form-item>
            <!--可编辑区域 end-->
        </a-form>
    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {sys_dict_controller} from "@/api/adminService";

export default {
    name: "AddOrEditDictItem",
    mixins: [formMixin],
    components: {},
    data() {
        return {
            form: {
                id: null,
                dictTitle: null,
                dictValue: null,
                style: null,
                enabled: null,
                groupNumber: null,
                sort: null,
            },
            rules: {
                id: [],
                groupNumber: [
                    dataCheck.required({}),
                ],
                dictTitle: [
                    dataCheck.required({}),
                ],
                dictValue: [
                    dataCheck.required({}),
                ],
                style: [],
                enabled: [
                    dataCheck.required({type: 'number'}),
                ],
                sort: [
                    dataCheck.required({type: 'number'}),
                ],
            },
            submitUrl: sys_dict_controller.saveOrUpdate,
            postMethod: 'post_json'
        }
    },
    methods: {},
}
</script>
<style scoped lang="less">
</style>
